import React, { useEffect, useState } from 'react';
import RightMenu from '../NavBar/Sections/RightMenu';
import FileUpload from '../../utils/FileUpload';
import Axios from 'axios';
import AWS, { awsBucketName, deleteStoredImage } from '../../utils/S3Helper';

function OthersPage(props) {
    const [user, setUser] = useState()

    useEffect(() => {
        setUser(props?.user?.userData);
    }, [props.user])

    const updateImages = (newImages) => {
        console.log('프로필 이미지 업데이트', newImages);

        if (!newImages || newImages.length < 1) {
            console.log('업데이트할 이미지 없음:', newImages);
            return;
        }

        const file = newImages[0];
        const imgUrlOld = props.user.userData.image;

        const promiseUploadImg = new AWS.S3.ManagedUpload({
            params: {
                Bucket: awsBucketName,
                Key: `profile/${props.user.userData.email.replaceAll('@', '_')}/profile_${Date.now()}`,
                Body: file,
                ContentType: file.type,
            },
        }).promise().then(data => {
            return Axios.post('/api/user/update', { image: data.Location });
        }).then(resp => {
            console.log('success update', resp);
            if (resp.data.success) {
                //delete old image from S3
                deleteStoredImage(props, [imgUrlOld]);
            }
        }).catch(alert);
    }

    return (
        <div className='page'>
            {
                user && <>
                    {/* <FileUpload imgSrc={user.image} refreshFunction={updateImages} isProfile={true} />
                    {user.name}<br />
                    {user.email}<br />
                    {user.phone}<br /> */}
                    <RightMenu mode="inline" />
                </>
            }
        </div>
    )
}

export default OthersPage